._label_160dj_1 {
  font-size: 12px;
  cursor: pointer;
}

._value_160dj_6 {
  font-size: 12px;
  line-height: 20px;
}